import { Component } from '@angular/core';
import { ClassTransformerHelper } from '../../../../helpers/class.transformer.helper';
import { InjectorHelper } from '../../../../helpers/injector.helper';
import { WorkflowType } from '../../../../models/enums/workflowtype.enum';
import { WorkflowModuleExecuter, WorkflowStatus } from '../../../../models/workflow/workflow.model';
import { UserSettingsService } from '../../../../services/usersettings.service';
import { WorkflowExitInfo, WorkflowModuleSettingsHelper, WorkflowRegistry } from '../../../../services/workflow.service';
import { DataCheck, WorkflowDialogContent } from '../../../workflow.dialog';

@Component({
    selector: 'wf-readprofiles-settings',
    templateUrl: './read.profiles.settings.html'
})
export class ReadProfilesSettings extends WorkflowDialogContent {
    Data = new ReadProfilesSettingsData();

    public static GetRegistry(): WorkflowRegistry {
        const reg = new WorkflowRegistry();
        reg.ID = 'readProfilesModule';
        reg.Caption = '@@Read profiles';
        reg.GroupID = 'profileGroup';
        reg.Index = 30;
        reg.SettingsControl = ReadProfilesSettings;
        reg.SettingsTypeHelper = new ReadProfilesSettingsDataHelper();
        reg.Executer = ReadProfilesModuleExecuter;
        reg.WorkflowType = WorkflowType.Client;
        return reg;
    }

    initialize(data: any) {
        super.initialize(data);
        if (data) {
            this.Data = ClassTransformerHelper.CopyObject(data, ReadProfilesSettingsData);
        }
    }

    checkData(): DataCheck {
        const retVal = new DataCheck();
        if (this.Data && !this.Data.StatusKey && !this.Data.UseForState) {
            retVal.IsCorrect = false;
            retVal.Error = '@@SetKeyOrStateError';
        }
        return retVal;
    }

    getResult(): any {
        return this.Data;
    }
}

export class ReadProfilesSettingsData {
    StatusKey: string;
    UseForState = false;
    IgnoreUser = false;
}

export class ReadProfilesSettingsDataHelper extends WorkflowModuleSettingsHelper {
    getExitPoints(settings: any): WorkflowExitInfo[] {
        return [new WorkflowExitInfo()];
    }
    getEmptySettingsInstance() {
        return new ReadProfilesSettingsData();
    }
    async fillActualState(module: any, state: any, wfData: any) {
        if (state) {
            const settings = WorkflowModuleSettingsHelper.GetSettingsFromModule(module);
            if (settings && settings.StatusKey) {
                WorkflowModuleSettingsHelper.AddStatusKeysToState(state, [settings.StatusKey]);
            }
        }
    }
}

export class ReadProfilesModuleExecuter extends WorkflowModuleExecuter {
    async execute(status: WorkflowStatus): Promise<number> {
        return new Promise<number>(resolve => {
            const layout = status.WorkflowLayoutService.Layout;
            if (layout) {
                if (status.ActualSettings) {
                    const service = InjectorHelper.InjectorInstance.get<UserSettingsService>(UserSettingsService);
                    const sCall = status.ActualSettings.IgnoreUser ?
                        service.ReadProfileByLayoutAllUsers(layout._Id) :
                        service.ReadProfileByLayout(layout._Id);
                    sCall.subscribe(retVal => {
                        if (status.ActualSettings.StatusKey) {
                            status.Context.set(status.ActualSettings.StatusKey, retVal);
                        }
                        if (status.ActualSettings.UseForState) {
                            status.ActualParameter = retVal;
                        }
                        resolve(0);
                    });
                    return;
                } else {
                    status.Logger.logError('Read profiles modul: No settings found.');
                }
            } else {
                status.Logger.logError('Read profiles modul: No layout found.');
            }
            resolve(super.execute(status));
        });
    }
}
